"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RectangleTransformRotationHandler_instances, _RectangleTransformRotationHandler_drawingTools, _RectangleTransformRotationHandler_handleDistance, _RectangleTransformRotationHandler_rotationConfig, _RectangleTransformRotationHandler_onMove, _RectangleTransformRotationHandler_onCommit, _RectangleTransformRotationHandler_handleLocalPoint, _RectangleTransformRotationHandler_cumulativeRotation, _RectangleTransformRotationHandler_M_accumulatedRotation, _RectangleTransformRotationHandler_gestureStartCumulative, _RectangleTransformRotationHandler_gestureCenter, _RectangleTransformRotationHandler_dragStart, _RectangleTransformRotationHandler_commitAndFlush, _RectangleTransformRotationHandler_composeDeltaIntoMatrix, _RectangleTransformRotationHandler_beginDrag, _RectangleTransformRotationHandler_applyDrag, _RectangleTransformRotationHandler_clampAngle, _RectangleTransformRotationHandler_snapCumulative;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleTransformRotationHandler = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_features_drawing_tools_1 = require("@shapediver/viewer.features.drawing-tools");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const gl_matrix_1 = require("gl-matrix");
const rotationDefaultTextures = {};
rotationDefaultTextures["variation_0"] = viewer_1.MaterialEngine.instance
    .loadMap("https://viewer.shapediver.com/v3/graphics/refresh.png")
    .then((mapData) => {
    rotationDefaultTextures["variation_0"] = mapData;
    return mapData;
});
function snapAngle(angle, step, threshold) {
    const nearest = Math.round(angle / step) * step;
    return Math.abs(angle - nearest) <= threshold ? nearest : angle;
}
function normalizeSignedAngle(angle) {
    return (((angle % (2 * Math.PI)) + 3 * Math.PI) % (2 * Math.PI)) - Math.PI;
}
class RectangleTransformRotationHandler {
    constructor(viewport, parentNode, localPoints, rotationConfig = {
        step: undefined,
        stepThreshold: undefined,
        min: undefined,
        max: undefined,
        handleDistance: 0.25,
        visualization: undefined,
    }, onMove = () => { }, onCommit = () => { }) {
        var _a, _b;
        _RectangleTransformRotationHandler_instances.add(this);
        _RectangleTransformRotationHandler_drawingTools.set(this, void 0);
        _RectangleTransformRotationHandler_handleDistance.set(this, void 0);
        _RectangleTransformRotationHandler_rotationConfig.set(this, void 0);
        _RectangleTransformRotationHandler_onMove.set(this, void 0);
        _RectangleTransformRotationHandler_onCommit.set(this, void 0);
        _RectangleTransformRotationHandler_handleLocalPoint.set(this, void 0);
        // Running cumulative rotation used for min/max enforcement and snapping.
        _RectangleTransformRotationHandler_cumulativeRotation.set(this, 0);
        // Accumulated rotation expressed as a matrix (plane-LS). Each committed
        // gesture is composed on top of the previous one, so multiple rotations
        // with different centers (e.g. after asymmetric scaling) are handled
        // correctly without collapsing them to a single angle + single center.
        _RectangleTransformRotationHandler_M_accumulatedRotation.set(this, gl_matrix_1.mat4.create());
        // Cumulative rotation and center captured at the START of each gesture
        // (preserved across clearDragState so syncAccumulatedToCumulative can use
        // them when pointer-out fires mid-gesture).
        _RectangleTransformRotationHandler_gestureStartCumulative.set(this, 0);
        _RectangleTransformRotationHandler_gestureCenter.set(this, gl_matrix_1.vec3.create());
        // Drag-start snapshot captured on the first DRAG_MOVE of each gesture.
        _RectangleTransformRotationHandler_dragStart.set(this, undefined);
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_onMove, onMove, "f");
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_onCommit, onCommit, "f");
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_handleDistance, (_a = rotationConfig.handleDistance) !== null && _a !== void 0 ? _a : 0.25, "f");
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_rotationConfig, {
            step: (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.step) !== undefined &&
                (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.step) !== null
                ? rotationConfig.step * (Math.PI / 180)
                : undefined,
            stepThreshold: (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.stepThreshold) !== undefined &&
                (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.stepThreshold) !== null
                ? rotationConfig.stepThreshold * (Math.PI / 180)
                : undefined,
            min: (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.min) !== undefined &&
                (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.min) !== null
                ? rotationConfig.min * (Math.PI / 180)
                : undefined,
            max: (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.max) !== undefined &&
                (rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.max) !== null
                ? rotationConfig.max * (Math.PI / 180)
                : undefined,
            handleDistance: (_b = rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.handleDistance) !== null && _b !== void 0 ? _b : 0.25,
            visualization: rotationConfig === null || rotationConfig === void 0 ? void 0 : rotationConfig.visualization,
        }, "f");
        // Place the handle above the top edge (M5) by handleDistance * height
        const min = localPoints[0]; // C0 in local space (bottom-left)
        const max = localPoints[4]; // C4 in local space (top-right)
        const rotHandleDist = (max[1] - min[1]) * __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleDistance, "f");
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_handleLocalPoint, gl_matrix_1.vec3.fromValues((min[0] + max[0]) / 2, max[1] + rotHandleDist, 0), "f");
        // XY-plane restriction in parent-local space.
        const rotVis = rotationConfig.visualization;
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_drawingTools, (0, viewer_features_drawing_tools_1.createDrawingTools)(viewport, { onUpdate: () => { }, onCancel: () => { } }, {
            general: {
                enableInsertion: false,
                enableDeletion: false,
                enableSelection: false,
            },
            geometry: {
                mode: "points",
                points: [
                    [
                        __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f")[0],
                        __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f")[1],
                        __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f")[2],
                    ],
                ],
                minPoints: 1,
                maxPoints: 1,
            },
            restrictions: {
                plane: {
                    type: viewer_rendering_engine_intersection_restriction_engine_1.RESTRICTION_TYPE.PLANE,
                    origin: gl_matrix_1.vec3.create(),
                    vector_u: gl_matrix_1.vec3.fromValues(1, 0, 0),
                    vector_v: gl_matrix_1.vec3.fromValues(0, 1, 0),
                    createHelperObjects: false,
                },
            },
            visualization: Object.assign(Object.assign({ distanceMultiplicationFactor: 1, distanceLabels: false, pointerPosition: false }, rotVis), { points: Object.assign({ size_0: 50, size_1: 50, size_2: 50, size_3: 50, color: "#000" }, rotVis === null || rotVis === void 0 ? void 0 : rotVis.points) }),
        }, rotationDefaultTextures, parentNode), "f");
    }
    get drawingTools() {
        return __classPrivateFieldGet(this, _RectangleTransformRotationHandler_drawingTools, "f");
    }
    get handleLocalPoint() {
        return __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f");
    }
    get accumulatedRotationMatrix() {
        return __classPrivateFieldGet(this, _RectangleTransformRotationHandler_M_accumulatedRotation, "f");
    }
    /**
     * Clear the drag-start snapshot at the end of a gesture.
     */
    clearDragState() {
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_dragStart, undefined, "f");
    }
    close() {
        __classPrivateFieldGet(this, _RectangleTransformRotationHandler_drawingTools, "f").close();
    }
    /**
     * Sync accumulated to cumulative — called on pointer-out to commit any
     * in-progress gesture without a proper DRAG_END.
     */
    syncAccumulatedToCumulative() {
        const deltaAngle = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_cumulativeRotation, "f") - __classPrivateFieldGet(this, _RectangleTransformRotationHandler_gestureStartCumulative, "f");
        if (deltaAngle !== 0) {
            __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_composeDeltaIntoMatrix).call(this, __classPrivateFieldGet(this, _RectangleTransformRotationHandler_gestureCenter, "f"), deltaAngle);
        }
        // Advance the gesture baseline so a second call is idempotent.
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_gestureStartCumulative, __classPrivateFieldGet(this, _RectangleTransformRotationHandler_cumulativeRotation, "f"), "f");
    }
    /**
     * Process a drag event: runs the full snapping/clamping pipeline and calls
     * onMove (temporary drag-move) or onCommit (drag-end) as appropriate.
     */
    processDrag(ev, localPoints, commit) {
        var _a;
        __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_beginDrag).call(this, localPoints);
        const { deltaAngle: rawDelta } = this.computeDrag(ev, localPoints);
        const rawNext = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_cumulativeRotation, "f") + rawDelta;
        const snappedNext = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_snapCumulative).call(this, rawNext);
        const finalNext = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_clampAngle).call(this, snappedNext);
        if (finalNext === __classPrivateFieldGet(this, _RectangleTransformRotationHandler_cumulativeRotation, "f")) {
            // Angle unchanged: only commit the parent matrix on DRAG_END so the
            // object does not reset (DRAG_END almost always hits this branch).
            if (commit) {
                __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_commitAndFlush).call(this, finalNext, localPoints);
            }
            else if (((_a = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_rotationConfig, "f")) === null || _a === void 0 ? void 0 : _a.step) !== undefined) {
                // When a step is configured, keep the handle pinned at the current
                // snapped position so the DT point does not drift with the raw cursor.
                __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_applyDrag).call(this, __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f"), true);
            }
            return;
        }
        const drag = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_dragStart, "f");
        const absoluteDelta = finalNext - drag.cumulative;
        const { rotated, newHandle } = this.computeDragByAngle(drag.localPoints, absoluteDelta, drag.handle);
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_cumulativeRotation, finalNext, "f");
        if (commit) {
            // On commit: bake rotation into the parent matrix and flush canonical
            // (axis-aligned) DT positions — the parent matrix now carries the rotation.
            __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_commitAndFlush).call(this, finalNext, localPoints);
        }
        else {
            // On drag-move: temporarily move DT points so the viewport renders them
            // at the rotated positions without updating the parent matrix yet.
            __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_applyDrag).call(this, newHandle, true);
            __classPrivateFieldGet(this, _RectangleTransformRotationHandler_onMove, "f").call(this, rotated);
        }
    }
    /**
     * Process a drag event on the rotation handle, computing the new rectangle points and handle position.
     * Returns the deltaAngle (in radians, after snapping) so the caller can track cumulative rotation.
     */
    computeDrag(ev, localPoints) {
        const newHandleLS = gl_matrix_1.vec3.fromValues(ev.points[0][0], ev.points[0][1], ev.points[0][2]);
        const cx = (localPoints[0][0] + localPoints[4][0]) / 2;
        const cy = (localPoints[0][1] + localPoints[4][1]) / 2;
        const currVec = gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f"), gl_matrix_1.vec3.fromValues(cx, cy, 0));
        const newVec = gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), newHandleLS, gl_matrix_1.vec3.fromValues(cx, cy, 0));
        const deltaAngle = normalizeSignedAngle(Math.atan2(newVec[1], newVec[0]) -
            Math.atan2(currVec[1], currVec[0]));
        const { rotated, newHandle } = this.rotatePoints(localPoints, cx, cy, deltaAngle);
        return { rotated, newHandle, deltaAngle };
    }
    /**
     * Snap a cumulative angle to the nearest configured step increment.
     * If no step is configured, returns the angle unchanged.
     * @deprecated Use processDrag which handles snapping internally.
     */
    snapCumulative(cumulative) {
        return __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_snapCumulative).call(this, cumulative);
    }
    /**
     * Rotate localPoints by an explicit angle (radians) around their center.
     */
    computeDragByAngle(localPoints, deltaAngle, startHandle) {
        const cx = (localPoints[0][0] + localPoints[4][0]) / 2;
        const cy = (localPoints[0][1] + localPoints[4][1]) / 2;
        return this.rotatePoints(localPoints, cx, cy, deltaAngle, startHandle);
    }
    rotatePoints(localPoints, cx, cy, deltaAngle, startHandle) {
        const cos = Math.cos(deltaAngle);
        const sin = Math.sin(deltaAngle);
        const rotated = localPoints.map((p) => {
            const du = p[0] - cx;
            const dv = p[1] - cy;
            return gl_matrix_1.vec3.fromValues(cx + du * cos - dv * sin, cy + du * sin + dv * cos, 0);
        });
        const h = startHandle !== null && startHandle !== void 0 ? startHandle : __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f");
        const dhU = h[0] - cx;
        const dhV = h[1] - cy;
        const newHandle = gl_matrix_1.vec3.fromValues(cx + dhU * cos - dhV * sin, cy + dhU * sin + dhV * cos, 0);
        return { rotated, newHandle };
    }
    /**
     * Recompute the handle position based on the new rectangle points, and move the drawing-tools point accordingly.
     * @param localPoints
     * @param temporary
     */
    recompute(localPoints, temporary) {
        const center = gl_matrix_1.vec3.fromValues((localPoints[0][0] + localPoints[4][0]) / 2, (localPoints[0][1] + localPoints[4][1]) / 2, 0);
        const m5 = localPoints[5];
        const dist = 2 * __classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleDistance, "f");
        const newHandle = gl_matrix_1.vec3.fromValues(m5[0] + dist * (m5[0] - center[0]), m5[1] + dist * (m5[1] - center[1]), 0);
        __classPrivateFieldSet(this, _RectangleTransformRotationHandler_handleLocalPoint, newHandle, "f");
        __classPrivateFieldGet(this, _RectangleTransformRotationHandler_drawingTools, "f").movePoint(0, [newHandle[0], newHandle[1], newHandle[2]], temporary);
    }
}
exports.RectangleTransformRotationHandler = RectangleTransformRotationHandler;
_RectangleTransformRotationHandler_drawingTools = new WeakMap(), _RectangleTransformRotationHandler_handleDistance = new WeakMap(), _RectangleTransformRotationHandler_rotationConfig = new WeakMap(), _RectangleTransformRotationHandler_onMove = new WeakMap(), _RectangleTransformRotationHandler_onCommit = new WeakMap(), _RectangleTransformRotationHandler_handleLocalPoint = new WeakMap(), _RectangleTransformRotationHandler_cumulativeRotation = new WeakMap(), _RectangleTransformRotationHandler_M_accumulatedRotation = new WeakMap(), _RectangleTransformRotationHandler_gestureStartCumulative = new WeakMap(), _RectangleTransformRotationHandler_gestureCenter = new WeakMap(), _RectangleTransformRotationHandler_dragStart = new WeakMap(), _RectangleTransformRotationHandler_instances = new WeakSet(), _RectangleTransformRotationHandler_commitAndFlush = function _RectangleTransformRotationHandler_commitAndFlush(finalNext, localPoints) {
    const center = gl_matrix_1.vec3.fromValues((localPoints[0][0] + localPoints[4][0]) / 2, (localPoints[0][1] + localPoints[4][1]) / 2, 0);
    const deltaAngle = finalNext - __classPrivateFieldGet(this, _RectangleTransformRotationHandler_gestureStartCumulative, "f");
    if (deltaAngle !== 0) {
        __classPrivateFieldGet(this, _RectangleTransformRotationHandler_instances, "m", _RectangleTransformRotationHandler_composeDeltaIntoMatrix).call(this, center, deltaAngle);
    }
    // Advance baseline so the next gesture starts from the right offset.
    __classPrivateFieldSet(this, _RectangleTransformRotationHandler_gestureStartCumulative, finalNext, "f");
    __classPrivateFieldSet(this, _RectangleTransformRotationHandler_dragStart, undefined, "f");
    this.recompute(localPoints, false);
    __classPrivateFieldGet(this, _RectangleTransformRotationHandler_onCommit, "f").call(this, localPoints);
}, _RectangleTransformRotationHandler_composeDeltaIntoMatrix = function _RectangleTransformRotationHandler_composeDeltaIntoMatrix(center, deltaAngle) {
    const negCenter = gl_matrix_1.vec3.negate(gl_matrix_1.vec3.create(), center);
    const M_delta = gl_matrix_1.mat4.multiply(gl_matrix_1.mat4.create(), gl_matrix_1.mat4.fromTranslation(gl_matrix_1.mat4.create(), center), gl_matrix_1.mat4.multiply(gl_matrix_1.mat4.create(), gl_matrix_1.mat4.fromZRotation(gl_matrix_1.mat4.create(), deltaAngle), gl_matrix_1.mat4.fromTranslation(gl_matrix_1.mat4.create(), negCenter)));
    gl_matrix_1.mat4.multiply(__classPrivateFieldGet(this, _RectangleTransformRotationHandler_M_accumulatedRotation, "f"), __classPrivateFieldGet(this, _RectangleTransformRotationHandler_M_accumulatedRotation, "f"), M_delta);
}, _RectangleTransformRotationHandler_beginDrag = function _RectangleTransformRotationHandler_beginDrag(localPoints) {
    if (__classPrivateFieldGet(this, _RectangleTransformRotationHandler_dragStart, "f") !== undefined)
        return;
    __classPrivateFieldSet(this, _RectangleTransformRotationHandler_gestureStartCumulative, __classPrivateFieldGet(this, _RectangleTransformRotationHandler_cumulativeRotation, "f"), "f");
    __classPrivateFieldSet(this, _RectangleTransformRotationHandler_gestureCenter, gl_matrix_1.vec3.fromValues((localPoints[0][0] + localPoints[4][0]) / 2, (localPoints[0][1] + localPoints[4][1]) / 2, 0), "f");
    __classPrivateFieldSet(this, _RectangleTransformRotationHandler_dragStart, {
        localPoints: localPoints.map((p) => gl_matrix_1.vec3.clone(p)),
        handle: gl_matrix_1.vec3.clone(__classPrivateFieldGet(this, _RectangleTransformRotationHandler_handleLocalPoint, "f")),
        cumulative: __classPrivateFieldGet(this, _RectangleTransformRotationHandler_cumulativeRotation, "f"),
    }, "f");
}, _RectangleTransformRotationHandler_applyDrag = function _RectangleTransformRotationHandler_applyDrag(newHandle, temporary) {
    __classPrivateFieldSet(this, _RectangleTransformRotationHandler_handleLocalPoint, newHandle, "f");
    __classPrivateFieldGet(this, _RectangleTransformRotationHandler_drawingTools, "f").movePoint(0, [newHandle[0], newHandle[1], newHandle[2]], temporary);
}, _RectangleTransformRotationHandler_clampAngle = function _RectangleTransformRotationHandler_clampAngle(snappedNext) {
    const { min, max } = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_rotationConfig, "f");
    if (min !== undefined && max !== undefined)
        return Math.min(max, Math.max(min, snappedNext));
    if (min !== undefined)
        return Math.max(min, snappedNext);
    if (max !== undefined)
        return Math.min(max, snappedNext);
    return snappedNext;
}, _RectangleTransformRotationHandler_snapCumulative = function _RectangleTransformRotationHandler_snapCumulative(cumulative) {
    const { step, stepThreshold } = __classPrivateFieldGet(this, _RectangleTransformRotationHandler_rotationConfig, "f");
    if (step === undefined)
        return cumulative;
    return snapAngle(cumulative, step, stepThreshold !== null && stepThreshold !== void 0 ? stepThreshold : step / 2);
};
//# sourceMappingURL=RectangleTransformRotationHandler.js.map